<div *ngIf="allow && zoomAllow" class="internet" [ngClass]="!isInternet ? 'no-internet' : 'internet'">
    <router-outlet></router-outlet>
</div>

<div class="floating" *ngIf="allow  && zoomAllow">
<!--    <div class="row">-->
<!--        <div class="column">-->
            <div id="meetingSDKElement"></div>
<!--        </div>-->
<!--        <div class="column">-->
            <div id="meetingSDKChatElement"></div>
<!--        </div>-->
<!--    </div>-->
<!--</div>-->
</div>
<div [ngClass]="!isInternet ? 'no-internet overlay' : 'internet overlay-hidden'">
    <div class="row w-100" style="background: red;justify-content: center;">
        <span>Your Internet Connection is Unstable</span>
    </div>
</div>
<div *ngIf="!allow" class="internet" [ngClass]="isInternet ? 'no-internet' : 'internet'">
    <div [ngClass]="isInternet ? 'no-internet overlay' : 'internet overlay-hidden'">
        <div class="row w-100" style="background: red;justify-content: center;">
            <span>Your Internet Connection is Unstable</span>
        </div>
    </div>
</div>

<ng-template #updateVersionNumber let-c="close" let-d="dismiss">
    <div class="modal-header align-items-center">
        <h5 class="modal-title font-weight-bold">Version Updated</h5>
    </div>
    <div class="modal-body">
        <div class="col-md-12 px-0">
            <p class="mb-0" style="font-size: 14px; color: rgba(65,69,81,0.87)">A <b>new version {{newVersionNumber}}</b> is available. Please click <b>Update Version</b> to continue. If you continue to see this message, please clear your browser cache and refresh the page.</p>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn cancel" type="button" (click)="modalRef.close()">Update Version</button>
    </div>
</ng-template>
